import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Shield, Star } from 'lucide-react';

const SocialProof = () => {
  const proofPoints = [
    { icon: Zap, text: '2-4 Week Delivery' },
    { icon: Shield, text: 'Fixed Pricing' },
    { icon: Star, text: 'Quality Guaranteed' },
  ];

  return (
    <section className="py-6 bg-[#1a237e]" data-testid="social-proof-section">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-12 text-white"
        >
          <span className="text-sm md:text-base font-medium opacity-90">
            Trusted by businesses across Bangalore
          </span>
          <div className="flex items-center gap-6 md:gap-8">
            {proofPoints.map((point, index) => (
              <div key={index} className="flex items-center gap-2">
                <point.icon className="w-4 h-4 text-[#00e5ff]" />
                <span className="text-sm font-medium opacity-90">{point.text}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SocialProof;
